import React, { Component, createRef, useEffect } from 'react'
import { connect } from 'react-redux'
import saveAs from 'file-saver';
import { jsPDF } from 'jspdf';
import { gapi } from 'gapi-script';
import { setVerifyInputFile, setVerifyDSInputFile, clearVerifyInputFile,
		clearVerifyDSInputFile, clearVerifyResultData, clearFileSignedData, setVerifyDSExpand, clearModifiedDSData, setIsLoading, setSignatureDifferenceType,
		clearSignatureDifferenceType, setShowPreviewPopupVerify, setGoogleAccessToken, setGoogleTokenExpiryTime, setShowUpgradeCard } from '../../actions/localStates'

import { checkExtensionVerify, fromBytes } from '../../actions/stringEncodersFuncs'
import { bindActionCreators } from 'redux'
import i18next from 'i18next'

import logo from '../../img/gDriveLogo.png'

import '../../fonts/Roboto-Regular-normal.js';
import '../../fonts/Roboto-Regular-bold.js';
import '../../fonts/Roboto-Bold-normal.js';

import '../../fonts/Hauora-ExtraBold-bold.js';
import '../../fonts/Hauora-ExtraBold-normal.js';
import '../../fonts/Hauora-Regular-normal.js';
import '../../fonts/KharkivTone04_10_2020-normal.js';


import VerifyDSOptionsContainer from '../../containers/VerifyDSOptionsContainer'
import VerifyTextDSContainer from '../../containers/VerifyTextDSContainer'

import PreviewPopup from '../../containers/PreviewPopup'
import GooglePicker from './GooglePicker'

import QRPopup from './QRPopup'
import PrivateSignPopup from './PrivateSignPopup'

import Dropzone from 'react-dropzone';

const dropzoneRef = createRef();
const dropzoneDSRef = createRef();

function normalizeOid(oid) {
  const baseOids = [
    "1.2.804.2.1.1.1.1.3.6",
  	"1.2.804.2.1.1.1.1.3.1"
  ];

  for (const base of baseOids) {
    if (oid === base || oid.startsWith(base + ".")) {
      return base;
    }
  }

  return oid;
}

class VerifyDSTab extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	isLoading: false,
	    	collapseVerifyDSShow: "",
	    	showPopup: false,
	    	displayedData: null,
	    	file: null,
            fileId: null,
            fileName: '',
            mimeType: '',
            pickerApiLoaded: false,
            showPrivateSignPopup: false
	    }

	    this.CLIENT_ID = this.props.base.googleDriveClientId;
        this.API_KEY = this.props.base.googleDriveApiKey;
        this.SCOPE = 'https://www.googleapis.com/auth/drive.file';
        this.authToken = null;
        this.isPickerInitialized = false;

        this.initPicker = this.initPicker.bind(this);

	    this.showDsVerifyResults = this.showDsVerifyResults.bind(this);
	    this.handleShowQR = this.handleShowQR.bind(this);

	    this.handleOnDrop = this.handleOnDrop.bind(this);
	    this.handleOnDropDS = this.handleOnDropDS.bind(this);

	    this.copyVerifyResults = this.copyVerifyResults.bind(this);
	    this.generateTextResult = this.generateTextResult.bind(this);

	    this.saveVerifyResultsToPdf = this.saveVerifyResultsToPdf.bind(this);

	    this.showPreviewPopupVerify = this.showPreviewPopupVerify.bind(this);

	    this.uploadFileToDrive = this.uploadFileToDrive.bind(this);
	    this.onPickerApiLoad = this.onPickerApiLoad.bind(this);

	    this.openFolderPicker = this.openFolderPicker.bind(this);
	    this.pickerCallback = this.pickerCallback.bind(this);

	    this.checkForFolders = this.checkForFolders.bind(this);

	    this.handleShowPrivateSign = this.handleShowPrivateSign.bind(this);
	}

	initPicker() {
		this.tokenClient = google.accounts.oauth2.initTokenClient({
	      client_id: this.CLIENT_ID,
	      scope: 'https://www.googleapis.com/auth/drive.file',
	      callback: (response) => {
	        if (response && response.access_token) {
	            this.props.actions.setGoogleAccessToken(response.access_token)
	            this.props.actions.setGoogleTokenExpiryTime(Date.now() + 3600 * 1000)

	            this.checkForFolders();
	        } else {
	          console.error("Authorization error:", response);
	        }
	      },
	    });
	    this.tokenClient.requestAccessToken();
    }

    checkForFolders = async () => {
    	var tokenExpiryTime = this.props.base.googleTokenExpiryTime
		if (tokenExpiryTime < Date.now()) {
	      this.initPicker();
	      return;
	    }

		try {
		  const response = await fetch(
		    'https://www.googleapis.com/drive/v3/files?q=mimeType=\'application/vnd.google-apps.folder\' and \'root\' in parents and trashed=false',
		    {
		      headers: new Headers({
		        'Authorization': `Bearer ${this.props.base.googleAccessToken}`,
		      }),
		    }
		  );
		  const data = await response.json();
		  
		  // Якщо є папки, відкриваємо Picker для вибору папки
		  if (data.files && data.files.length > 0) {
		    this.openFolderPicker();
		  } else {
		    // Якщо папок немає, завантажити файл в кореневий каталог
		    this.uploadFileToDrive('root');
		  }
		} catch (error) {
		  console.error('Error checking for folders:', error);
		}
	};

	openFolderPicker () {
		var tokenExpiryTime = this.props.base.googleTokenExpiryTime
		if (tokenExpiryTime < Date.now()) {
	      this.initPicker();
	      return;
	    }

		const picker = new window.google.picker.PickerBuilder()
		  .setOAuthToken(this.props.base.googleAccessToken)
		  .addView(new google.picker.DocsView(google.picker.ViewId.FOLDERS)
		  	.setIncludeFolders(true)
		  	.setSelectFolderEnabled(true)
		  	.setOwnedByMe(true)
		  )
		  .setDeveloperKey(this.props.base.googleDriveApiKey)
		  .setAppId(this.props.base.googleDriveAppId)
		  .setLocale('uk')
		  .setCallback(this.pickerCallback)
		  .build();

		picker.setVisible(true);
	};

	// Обробник результату вибору папки
	pickerCallback (data) {
		if (data.action === window.google.picker.Action.PICKED) {
		  const folder = data.docs[0];
		  console.log('Selected folder:', folder);
		  // setSelectedFolderId(folder.id);
		  this.uploadFileToDrive(folder.id)
		}
	};

    onPickerApiLoad() {
	    this.setState({ pickerApiLoaded: true });
	}

	uploadFileToDrive (folderId) {
        var name, _this = this;
		name = this.props.defaultState.fileWithDSName.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileWithDSName.substr(0, this.props.defaultState.fileWithDSName.lastIndexOf("."));

        var metadata;

        if (folderId !== null && folderId !== undefined) {
        	metadata = {
	            name: name,
	            parents: [folderId]
	        };
        } else {
        	metadata = {
	            name: name
	        };
        }
        

        const form = new FormData();
        form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
        form.append('file', _this.props.defaultState.fileSignedData);

        fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.base.googleAccessToken}`,
            },
            body: form,
        })
        .then(response => response.json())
        .then(data => {
            console.log('File uploaded successfully:', data);
            this.setState({ fileId: data.id });
            document.getElementById("uploadFiletoGoogleDriveButton").style.backgroundColor = "#c3e6cb";
            window.setTimeout(function () {
	        	document.getElementById("uploadFiletoGoogleDriveButton").style.backgroundColor = "#dddddd";
	        }, 1500)
        })
        .catch(error => {
            console.error('Error uploading file:', error);
        });
    }

	handleShowQR (i) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				qrLink: this.props.defaultState.verifyResultsForQR[i]
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    handleShowPrivateSign (base64Image) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				privateSignImage: base64Image
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPrivateSignPopup: !this.state.showPrivateSignPopup
        });
    }

	expandVerifyDS() {
		this.props.actions.setVerifyDSExpand(this.props.expandedCardsReducer.verifyExpanded)
		this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse"}) : this.setState({collapseVerifyDSShow: "card-body collapse show"})
	}

	buildFileInputSelector(){
		const fileInputSelector = document.getElementById('fileInputUpload');
		return fileInputSelector;
	}

	buildFileWithDSSelector(){
		const fileWithDSSelector = document.getElementById('fileWithDSUpload');
		return fileWithDSSelector;
	}

	componentDidMount(){
    	var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

    	this.fileInputSelector = this.buildFileInputSelector();
    	this.fileWithDSSelector = this.buildFileWithDSSelector();
    	this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse show"}) : this.setState({collapseVerifyDSShow: "card-body collapse"})

    	if (dropFile !== null) {
			dropFile.addEventListener('dragenter', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragover', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragleave', function(event) {
				dropFile.style.border = "";
			}, false);
		}

		if (dropDS !== null) {
			dropDS.addEventListener('dragenter', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragover', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragleave', function(event) {
				dropDS.style.border = "";
			}, false);
		}

		if (this.props.base.googleDriveEnabled === "true") {
			const script = document.createElement('script');
		    script.src = 'https://apis.google.com/js/api.js';
		    script.onload = () => window.gapi.load('picker', this.onPickerApiLoad);
		    document.body.appendChild(script);
		}
	}

	componentDidUpdate(prevProps) {
		var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

		if (prevProps.signatureType !== this.props.defaultOptionState.signatureType) {
			this.fileInputSelector = this.buildFileInputSelector();
		}

		if (this.state.isLoading && (this.props.defaultState.verifyResults || this.props.defaultState.verifyResults === undefined)) {
			this.setState({isLoading: false})
		}

		if (prevProps.fileInputSelected !== this.props.defaultState.fileInputSelected) {
			if (dropFile !== null) {
				dropFile.addEventListener('dragenter', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragover', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragleave', function(event) {
					dropFile.style.border = "";
				}, false);
			}
		}

		if (prevProps.fileWithDSSelected !== this.props.defaultState.fileWithDSSelected) {
			if (dropDS !== null) {
				dropDS.addEventListener('dragenter', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragover', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragleave', function(event) {
					dropDS.style.border = "";
				}, false);
			}
		}
	}

	verifyModifiedData () {
		var fileName;

		if (this.props.defaultState.fileInputName.length > 0) {
			fileName = this.props.defaultState.fileInputName + ".p7s"
		} else {
			fileName = this.props.defaultState.fileWithDSName
		}
    	saveAs(this.props.upgradeReducer.modifiedDSData, fileName)

		function blobToFile(blob, fileName, mimeType = blob.type) {
		    return new File([blob], fileName, { type: mimeType });
		}

		const blob = new Blob([this.props.upgradeReducer.modifiedDSData], { type: "application/pkcs7-signature" });
		const file = blobToFile(blob, fileName);

		this.props.actions.setShowUpgradeCard(false)
		this.props.actions.setVerifyDSInputFile(file)
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	handleFileInputSelect(e) {
		e.preventDefault();
		this.fileInputSelector.value = null;
	    this.fileInputSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	handleFileWithDSSelect(e) {
	    e.preventDefault();
	    this.fileWithDSSelector.value = null;
	    this.fileWithDSSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	onChangeInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 106954753)) {
			this.props.actions.setVerifyInputFile(e.target.files[0])
		}
	}

	handleOnDrop (files) {
		if (files[0] !== undefined && (files[0].size < 106954753)) {
			this.props.actions.setVerifyInputFile(files[0])
		}
	}

	onChangeDS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 106954753)) {
			this.props.actions.setVerifyDSInputFile(e.target.files[0])
		}
	}

	handleOnDropDS (files) {
		if (files[0] !== undefined && (files[0].size < 106954753)) {
			this.props.actions.setVerifyDSInputFile(files[0])
		}
	}

	setInputState() {
		this.props.actions.clearVerifyResultData()
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	cleanUpFileInputSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyInputFile()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearModifiedDSData()
	}

	cleanUpFileWithDSSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyDSInputFile()
		this.props.actions.clearModifiedDSData()
		this.props.actions.clearFileSignedData()
	}

	downloadModifiedData() {
		if (this.props.defaultState.fileInputName.length > 0) {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileInputName + ".p7s")
		} else {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileWithDSName)
		}
	}

	verifyModifiedData () {
		var fileName;

		if (this.props.defaultState.fileInputName.length > 0) {
			fileName = this.props.defaultState.fileInputName + ".p7s"
		} else {
			fileName = this.props.defaultState.fileWithDSName
		}
    	saveAs(this.props.upgradeReducer.modifiedDSData, fileName)

		function blobToFile(blob, fileName, mimeType = blob.type) {
		    return new File([blob], fileName, { type: mimeType });
		}

		const blob = new Blob([this.props.upgradeReducer.modifiedDSData], { type: "application/pkcs7-signature" });
		const file = blobToFile(blob, fileName);

		this.props.actions.setShowUpgradeCard(false)
		this.props.actions.setVerifyDSInputFile(file)
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	downloadSignedData() {
		// var name;
		// name = this.props.defaultState.fileWithDSName.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileWithDSName.substr(0, this.props.defaultState.fileWithDSName.lastIndexOf("."));
		// function removeExtraExtensions(filename) {
  //           return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$1');
  //       }

        function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

        // var dataFileName = removeExtraExtensions(name)
        var dataFileName = removeTrailingP7sExtensions(this.props.defaultState.fileWithDSName)

    	saveAs(this.props.defaultState.fileSignedData, dataFileName)
	}

	cleanUpForm(){
		this.cleanUpFileInputSelect()
		this.cleanUpFileWithDSSelect()
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearSignatureDifferenceType()
	}

	generateTextResult() {
		var strList = "", str = "", isValid, needSort = true;

		this.props.defaultState.verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				return;
			}
		})

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		if (needSort) {
			this.props.defaultState.verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			str = i18next.t("ds:signature") + (i + 1) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": " + isValid + "\n"

		    str += (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {
				str += i18next.t("ds:signer") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value + "\n"

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
					str += i18next.t("ds:organizationName") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
					str += i18next.t("ds:title") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
					str += i18next.t("ds:drfou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
					str += i18next.t("ds:edrpou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value + "\n"
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
		        	str += i18next.t("ds:eddrun") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value + "\n"
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		str += i18next.t("certificateSerialNumberTitle") + this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		str += i18next.t("ds:ca") + this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0) {
		       		str += i18next.t("ds:dsDate") + this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime) + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].contentTimestamp, "content")
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].signatureTimestamps[j], "signature")
					}
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value.length > 0) {
					var isElectronicStampTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:isElectronicStampTitle") + isElectronicStampTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value.length > 0) {
					var qualifiedCertTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value.length > 0) {
					var QSCDTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName) {
					var QSCDTypeTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value
					str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureType) {
					var signatureType = this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureType
					str += i18next.t("ds:signatureType") + i18next.t("ds:" + signatureType) + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat) {
					var signatureFormat;
					if (this.props.defaultState.verifyResults[i].signatureFormat !== null && this.props.defaultState.verifyResults[i].signatureFormat === "CADES_T" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false")
					{
                		signatureFormat = i18next.t("ds:CADES_TU")
                	} else {
                		signatureFormat = this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureFormat
                	}
					
					str += i18next.t("ds:signatureFormat") + i18next.t("ds:" + signatureFormat) + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureAlgorithmOid) {
					str += i18next.t("signatureAlgorithmOid") + i18next.t("ds:" + normalizeOid(this.props.defaultState.verifyResults[i].signatureAlgorithmOid)) + "\n"
		        }

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
					str += i18next.t("ds:lawMsgFirstRow") + "\n"
					str += i18next.t("ds:lawMsgSecondRow") + "\n"
					str += i18next.t("ds:lawMsgThirdRow") + "\n"
				}

				// if (this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
				// 	str += this.props.defaultState.verifyResults[i].failureCause
				// }
			} else {
				str += this.props.defaultState.verifyResults[i].failureCause + "\n"
			}

			strList += str + "\n";
		}

		return strList;
	}

	copyVerifyResults() {
		var textArea,
        copy;

	    function isOS() {
	        return navigator.userAgent.match(/ipad|iphone/i);
	    }

	    function createTextArea(text) {
	        textArea = document.createElement('textArea');
	        textArea.value = text;
	        textArea.style.cssText = "position: absolute";
	        textArea.style.cssText = "top: -9999px";
	        document.body.appendChild(textArea);
	    }

	    function selectText() {
	        var range,
	            selection;

	        if (isOS()) {
	            range = document.createRange();
	            range.selectNodeContents(textArea);
	            selection = window.getSelection();
	            selection.removeAllRanges();
	            selection.addRange(range);
	            textArea.setSelectionRange(0, 999999);
	        } else {
	            textArea.select();
	        }
	    }

	    function copyToClipboard() {        
	        document.execCommand('copy');
	        document.body.removeChild(textArea);
	    }

	    copy = function(text) {
	        createTextArea(text);
	        selectText();
	        copyToClipboard();
	        document.getElementById("copyLink").style.color = "green";
	        window.setTimeout(function () {
	        	document.getElementById("copyLink").style.color = "#1a0dab";
	        }, 1500)
		};

		copy(this.generateTextResult());
	}

	saveVerifyResultsToPdf () {
		var isValid, doc = new jsPDF(), dateNow = new Date(), cleaned = "", verticalOffset = 65, needSort = true, archTimestampCounter = 0, dataFileName = "", tempOffset = 0, tempOffsetSecond = 0, wrappedText, failureCauseSplited;
		var img = ' data:image/png;base64,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'

		this.props.defaultState.verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				return;
			}
		})

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		if (needSort) {
			this.props.defaultState.verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

		// doc.setFont('KharkivTone04_10_2020', 'normal');
		// doc.setFontSize(48);
		// doc.text("CIPHER", 10, 20);

		// var str = this.generateTextResult();
		function footer(){ 
			doc.setFont("Hauora-Regular", 'normal');
   			doc.setFontSize(10);
		    doc.text(198,292, doc.page.toString()); //print number bottom right
		    doc.page += 1;
		};

		doc.page = 1;

		footer()
		
		doc.addImage(img, 'PNG', 10, 13, 65, 10)
		doc.setFont('Hauora-Regular', 'normal');
		doc.setFontSize(8);

		doc.setTextColor("#1B4965");

		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.text(i18next.t("titlePdf"), 90, 15);
   		doc.text(i18next.t("addresTitlePdf"), 90, 19);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("streetAdddresPdf"), this.props.localesReducer.language === "en" ? 104 : 102, 19);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.text(i18next.t("phonePdf"), 90, 23);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text("+38 (044) 484-4612 |", 98, 23);
   		// doc.text("Факс: +38 (044) 483-0322", 100, 23);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.text("E-mail:", this.props.localesReducer.language === "en" ? 156 : 160, 19);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text("info@cipher.com.ua", this.props.localesReducer.language === "en" ? 167 : 170, 19);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.textWithLink("www.cipher.com.ua", 126, 23, {url: 'www.cipher.com.ua'});
   		doc.line(10, 30, 200, 30);

   		doc.setFont('Hauora-ExtraBold', 'bold');
   		doc.setFontSize(18);
   		doc.setTextColor("black");
   		doc.text(i18next.t("clientTitlePdf"), 105, 40, {align:'center'});

   		doc.text(i18next.t("protocolTitlePdf"), 105, 48, {align:'center'});

   		doc.setFontSize(10);
   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("verifyTitlePdf"), 105, 53, {align:'center'});

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("dateTimePdf"), 10, 60);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(dateNow.toLocaleString(), this.props.localesReducer.language === "en" ? 36 : 32, 60);


   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileNameWithDS"), 10, 66);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);

   		const maxWidth = 120;

		wrappedText = doc.splitTextToSize(this.props.defaultState.fileWithDS.name, maxWidth);
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 42 : 55, 66);

		if (wrappedText.length > 1) {
			tempOffset = 5;
		}
   		// doc.text(this.props.defaultState.fileWithDS.name, 55, 66);

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithDS"), 10, 70 + tempOffset);

   		var res, str = "";
		res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
		str = res.value + " " + i18next.t(res.unit);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 38 : 56, 70 + tempOffset);

   		var name = this.props.defaultState.fileWithDS.name.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDS.name : this.props.defaultState.fileWithDS.name.substr(0, this.props.defaultState.fileWithDS.name.lastIndexOf("."));

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		// doc.text(i18next.t("fileNameWithoutDS"), 10, 74 + tempOffset);
   		doc.text(i18next.t("fileNameWithoutDS"), 10, 74 + tempOffset);

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);

   		function hasSingleExtension(filename) {
		    const parts = filename.split(".");

		    return parts.length === 2;
		}

		function removeExtraExtensions(filename) {
            return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$0');
        }

        function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

		function hasAsicExtension(filename) {
		  const ext = filename.split('.').pop().toLowerCase();
		  return ext === 'asics' || ext === 'asice';
		}

   		if (!needSort) {
			// if (hasSingleExtension(this.props.defaultState.fileWithDS.name)) {
			// 	dataFileName = this.props.defaultState.fileWithDS.name
			// } else {
			// 	dataFileName = name
			// }

			if (this.props.defaultOptionState.signatureType === "detached") {
				dataFileName = this.props.defaultState.fileInput.name
			} else {
				cleaned = removeTrailingP7sExtensions(this.props.defaultState.fileWithDS.name);
				dataFileName = cleaned
			}

			if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
				dataFileName = "-"
			}

			if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
				dataFileName = "-"
			}

	        // const text = "Це дуже довгий текст, який потрібно автоматично перенести на новий рядок, якщо він не вміщується.";
			const maxWidth = 140; // Максимальна ширина тексту перед переносом

			wrappedText = doc.splitTextToSize(dataFileName, maxWidth);

			if (wrappedText.length > 1) {
				tempOffsetSecond = 5;
			}
			doc.text(wrappedText, this.props.localesReducer.language === "en" ? 45 : 56, 74 + tempOffset);
	  //       const maxWidth = 180;
			// const splittedText = doc.splitTextToSize(dataFileName, maxWidth);
			// doc.text(splittedText, 56, 74);
   		} else {
   // 			if (hasSingleExtension(this.props.defaultState.fileWithDS.name)) {
			// 	dataFileName = this.props.defaultState.fileWithDS.name
			// } else {
			// 	dataFileName = name
			// }

			if (this.props.defaultOptionState.signatureType === "detached") {
				dataFileName = this.props.defaultState.fileInput.name
			} else {
				cleaned = removeTrailingP7sExtensions(this.props.defaultState.fileWithDS.name);
				dataFileName = cleaned
			}

			if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
				dataFileName = "-"
			}

			if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
				dataFileName = "-"
			}

			// const text = "Це дуже довгий текст, який потрібно автоматично перенести на новий рядок, якщо він не вміщується.";
			const maxWidth = 140; // Максимальна ширина тексту перед переносом

			wrappedText = doc.splitTextToSize(dataFileName, maxWidth);

			if (wrappedText.length > 1) {
				tempOffsetSecond = 5;
			}
			doc.text(wrappedText, this.props.localesReducer.language === "en" ? 45 : 56, 74 + tempOffset);
			// const maxWidth = 180;
			// const splittedText = doc.splitTextToSize(dataFileName, maxWidth);
			// doc.text(splittedText, 56, 74);
   			// doc.text(dataFileName, 56, 74);
   		}

   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithoutDS"), 10, 78 + tempOffset + tempOffsetSecond);

   		if (this.props.defaultState.fileSignedData === null) {
   			if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
   				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
   			} else {
   			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
   			}
   		} else {
   			res = this.props.actions.fromBytes(this.props.defaultState.fileSignedData.size);
   		}

		str = res.value + " " + i18next.t(res.unit);

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			str = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			str = "-"
		}

   		doc.setFont("Hauora-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 43 : 58, 78 + tempOffset + tempOffsetSecond);


   		doc.setFont("Hauora-ExtraBold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("verifyResultsTitlePdf"), 10, 85 + tempOffset + tempOffsetSecond);

   		doc.setFont('Hauora-Regular', 'normal');
   		doc.text(i18next.t("verifySuccessPdf"), this.props.localesReducer.language === "en" ? 61 : 64, 85 + tempOffset + tempOffsetSecond);
   		// doc.text("Цілісність даних підтверджено.", 10, 69);

   		doc.setFontSize(10);
   		// doc.text(10, 78, str);

   		

   		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
   			if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
   				archTimestampCounter += 1;
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
   			} else {
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
   			}

   			if (this.props.defaultState.verifyResults[i].isUntrustedValid) {
				failureCauseSplited = this.props.defaultState.verifyResults[i].failureCause.split('\n')
			}

			// str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

			if (verticalOffset + 90 > 280) {
				verticalOffset = 10;
				doc.addPage();
				footer()
				doc.setFont('Hauora-Regular', 'normal');

				// var str = this.generateTextResult();
				
				// doc.addImage(img, 'PNG', 10, 13, 65, 10)
				// doc.setFont('Hauora-Regular', 'normal');
				// doc.setFontSize(8);

				// doc.setTextColor("#1B4965");

				// doc.setFont('Hauora-ExtraBold', 'bold');
		  //  		doc.text("Сайфер", 90, 15);
		  //  		doc.text("Адреса:", 90, 19);

		  //  		doc.setFont('Hauora-Regular', 'normal');
		  //  		doc.text("04107, Київ, вул. Нагірна 25/27, 3-ій поверх |", 102, 19);

		  //  		doc.setFont('Hauora-ExtraBold', 'bold');
		  //  		doc.text("Тел.:", 90, 23);

		  //  		doc.setFont('Hauora-Regular', 'normal');
		  //  		doc.text("+38 (044) 484-4612 |", 98, 23);
		  //  		// doc.text("Факс: +38 (044) 483-0322", 100, 23);

		  //  		doc.setFont('Hauora-ExtraBold', 'bold');
		  //  		doc.text("E-mail:", 160, 19);

		  //  		doc.setFont('Hauora-Regular', 'normal');
		  //  		doc.text("info@cipher.com.ua", 170, 19);

		  //  		doc.setFont('Hauora-ExtraBold', 'bold');
		  //  		doc.textWithLink("www.cipher.com.ua", 126, 23, {url: 'www.cipher.com.ua'});
		  //  		doc.line(10, 30, 200, 30);

		   		// doc.setFont('Hauora-ExtraBold', 'bold');
		   		// doc.setFontSize(18);
		   		// doc.setTextColor("black");
		   		// doc.text("Клієнт Єдиного сервісу криптографічних операцій", 105, 40, {align:'center'});

		   		// doc.text("ПРОТОКОЛ", 105, 48, {align:'center'});

		   		// doc.setFontSize(10);
		   		// doc.setFont('Hauora-Regular', 'normal');
		   		// doc.text("перевірки кваліфікованого електронного підпису", 105, 53, {align:'center'});

		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text("Дата та час: ", 10, 60);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(dateNow.toLocaleString(), 32, 60);


		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(i18next.t("fileNameWithDS"), 10, 64);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(this.props.defaultState.fileWithDS.name, 55, 64);

		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(i18next.t("fileSizeWithDS"), 10, 68);

				// res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
				// str = res.value + " " + i18next.t(res.unit);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(str, 56, 68);

		  //  		name = this.props.defaultState.fileWithDS.name.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDS.name : this.props.defaultState.fileWithDS.name.substr(0, this.props.defaultState.fileWithDS.name.lastIndexOf("."));

		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(i18next.t("fileNameWithoutDS"), 10, 72);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(name, 56, 72);

		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(i18next.t("fileSizeWithoutDS"), 10, 76);

		  //  		if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
	   // 				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
	   // 			} else {
	   // 			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
	   // 			}

				// str = res.value + " " + i18next.t(res.unit);

		  //  		doc.setFont("Hauora-Regular", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text(str, 58, 76);


		  //  		doc.setFont("Hauora-ExtraBold", 'normal');
		  //  		doc.setFontSize(10);
		  //  		doc.text("Результат перевірки підпису: ", 10, 85);

		  //  		doc.setFont('Hauora-Regular', 'normal');
		  //  		doc.text("Підпис перевірено успішно.", 63, 85);
		   		// doc.text("Цілісність даних підтверджено.", 10, 69);

		   		doc.setFontSize(10);
			}

			if (i === 0) {
				verticalOffset = verticalOffset + 27 + tempOffset + tempOffsetSecond
			} else {
				verticalOffset = verticalOffset + 8
			}
			

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("red");

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					}

					if (!needSort) {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 50 : 43, verticalOffset);
						}
					} else {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					}
					
				} else {
					doc.setFont("Hauora-ExtraBold", 'normal');

					if (this.props.defaultState.verifyResults[i].isValid) {
						doc.setTextColor("green");
					} else {
						doc.setTextColor("red");
					}

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					}

					if (!needSort) {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 50 : 43, verticalOffset);
						}
						
					} else {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					}
				}

				verticalOffset = verticalOffset + 5;
				doc.setFont("Hauora-ExtraBold", 'normal');
				doc.setTextColor("black");

				var isQualified
				if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:unqualifiedTitleShe")
				} else {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				}
				
				doc.text(isQualified, 10, verticalOffset);

				if (this.props.defaultState.verifyResults[i].failureCause !== null && this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("red");
					doc.text(this.props.defaultState.verifyResults[i].failureCause, 10, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:signer"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value, this.props.localesReducer.language === "en" ? 24 : 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {

					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:organizationName"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 160);
					doc.text([...wrappedText], this.props.localesReducer.language === "en" ? 35 : 33, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}
					// doc.text(, 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:title"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 160);
					doc.text([...wrappedText], 27, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 27, verticalOffset);
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:drfou"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value, this.props.localesReducer.language === "en" ? 25 : 27, verticalOffset);
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:edrpou"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value, 27, verticalOffset);
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		        	verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:eddrun"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value, 27, verticalOffset);
		        }

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:ca"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value, this.props.localesReducer.language === "en" ? 20 : 35, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("certificateSerialNumberTitleForPdf"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, ""), this.props.localesReducer.language === "en" ? 74 : 94, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		       		if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
			       		verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("red");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 38 : 35, verticalOffset);

						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("red");
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
							doc.text(i18next.t("dsTs") + ": ", 10, verticalOffset);
							doc.setFont("Hauora-Regular", 'normal');
							doc.text("Відсутня", 74, verticalOffset);
						}
						
					} else {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 38 : 35, verticalOffset);
					}
		       	}

		       	if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length > 0 && this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		verticalOffset = verticalOffset + 5;

					if (this.props.defaultState.verifyResults[i].contentTimestamp && this.props.defaultState.verifyResults[i].contentTimestamp.dateTime) {
			            if (this.props.defaultState.verifyResults[i].contentTimestamp.isFailure) {
			            	doc.setFont("Hauora-ExtraBold", 'normal');
			            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
			            	doc.setFont("Hauora-Regular", 'normal');
			            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
			            } else {
			            	isValid = this.props.defaultState.verifyResults[i].contentTimestamp.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

			            	doc.setFont("Hauora-ExtraBold", 'normal');
			            	doc.setTextColor("green");
			            	doc.text(i18next.t("dataTs") + ": " + isValid + "; ", 10, verticalOffset);
			            	doc.setFont("Hauora-Regular", 'normal');
			            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].contentTimestamp.dateTime), this.props.localesReducer.language === "en" ? 60 : 85, verticalOffset);

			            	if (this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber) {
			            		verticalOffset = verticalOffset + 5;
			            		doc.setTextColor("black");
			            		doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.text(i18next.t("tsaCertificateSerialNumberForPdf"), 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 82 : 102, verticalOffset);
			            	}
			            }
			        }
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime) {
							verticalOffset = verticalOffset + 5;
				            if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].isFailure) {
				            	doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
				            } else {
				            	isValid = this.props.defaultState.verifyResults[i].signatureTimestamps[j].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

				            	doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.setTextColor("green");
				            	doc.text(i18next.t("dsTs") + ": " + isValid + "; ", 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime), this.props.localesReducer.language === "en" ? 68 : 88, verticalOffset);

				            	if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber) {
				            		verticalOffset = verticalOffset + 5;
				            		doc.setTextColor("black");
				            		doc.setFont("Hauora-ExtraBold", 'normal');
					            	doc.text(i18next.t("tsaCertificateSerialNumberDSForPdf"), 10, verticalOffset);
					            	doc.setFont("Hauora-Regular", 'normal');
					            	doc.text(this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 97 : 95, verticalOffset);
				            	}
				            }
				        }

					}
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:isElectronicStampTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 41 : 48, verticalOffset);
	            }

	            if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:qualifiedCertTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 47 : 61, verticalOffset);
	            }

	            if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 23 : 29, verticalOffset);
	            }

	            if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTypeTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value, this.props.localesReducer.language === "en" ? 31 : 39, verticalOffset);
	            }

            	if (this.props.defaultState.verifyResults[i].signatureType && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:signatureType"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureType), this.props.localesReducer.language === "en" ? 38 : 40, verticalOffset);
            	}

            	if (this.props.defaultState.verifyResults[i].signatureFormat) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:signatureFormat"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');

					if (this.props.defaultState.verifyResults[i].signatureFormat !== null && this.props.defaultState.verifyResults[i].signatureFormat === "CADES_T" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false")
					{
                		doc.text(i18next.t("ds:CADES_TU"), 38, verticalOffset);
                	} else {
                		doc.text(this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureFormat), this.props.localesReducer.language === "en" ? 42 : 40, verticalOffset);
                	}
	            	
            	}

            	if (this.props.defaultState.verifyResults[i].signatureAlgorithmOid) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("signatureAlgorithmOid"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	var normilizedOid = "ds:" + normalizeOid(this.props.defaultState.verifyResults[i].signatureAlgorithmOid)
	            	doc.text(i18next.t(normilizedOid), this.props.localesReducer.language === "en" ? 47 : 44, verticalOffset)
		        }

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFirstRow"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSecondRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgThirdRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFourthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFifthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSixthRowPDF"), 10, verticalOffset);
				}

			} else {
				if (this.props.defaultState.verifyResults[i].isUntrustedValid) {
					if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("red");
						doc.text(i18next.t("ds:signature") + (i + 1) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
						if (!needSort) {
							doc.text(isValid, 43, verticalOffset);
						} else {
							doc.text(isValid, 27, verticalOffset);
						}
						
					} else {
						doc.setFont("Hauora-ExtraBold", 'normal');

						if (this.props.defaultState.verifyResults[i].isValid) {
							doc.setTextColor("green");
						} else {
							doc.setTextColor("red");
						}
						
						doc.text(i18next.t("ds:signature") + (i + 1) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
						if (!needSort) {
							doc.text(isValid, 43, verticalOffset);
						} else {
							doc.text(isValid, 27, verticalOffset);
						}
					}

					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					var isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
					doc.text(isQualified, 10, verticalOffset);

					// if (this.props.defaultState.verifyResults[i].failureCause !== null && this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
					// 	verticalOffset = verticalOffset + 5;
					// 	doc.setFont("Hauora-ExtraBold", 'normal');
					// 	doc.setTextColor("red");
					// 	doc.text(this.props.defaultState.verifyResults[i].failureCause, 10, verticalOffset);
					// }

					verticalOffset = verticalOffset + 5;
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:signer"), 10, verticalOffset);
					doc.setFont("Hauora-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value, 33, verticalOffset);

					if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:organizationName"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 33, verticalOffset);
					}

					if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:title"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 27, verticalOffset);
					}
					
					if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:drfou"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value, 27, verticalOffset);
					}
					
					if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:edrpou"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value, 27, verticalOffset);
					}
			        
			        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
			        	verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:eddrun"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value, 27, verticalOffset);
			        }
			       	
			       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
			       		verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("certificateSerialNumberTitleForPdf"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, ""), 94, verticalOffset);
			       	}

			       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
			       		verticalOffset = verticalOffset + 5;
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:ca"), 10, verticalOffset);
						doc.setFont("Hauora-Regular", 'normal');
						doc.text(this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value, 35, verticalOffset);
			       	}

			       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0) {
			       		if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
				       		verticalOffset = verticalOffset + 5;
							doc.setFont("Hauora-ExtraBold", 'normal');
							doc.setTextColor("red");
							doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
							doc.setFont("Hauora-Regular", 'normal');
							doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), 35, verticalOffset);

							verticalOffset = verticalOffset + 5;
							doc.setFont("Hauora-ExtraBold", 'normal');
							doc.setTextColor("red");
							if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
								doc.text(i18next.t("dsTs") + ": ", 10, verticalOffset);
								doc.setFont("Hauora-Regular", 'normal');
								doc.text("Відсутня", 74, verticalOffset);
							}
							
						} else {
							verticalOffset = verticalOffset + 5;
							doc.setFont("Hauora-ExtraBold", 'normal');
							doc.setTextColor("black");
							doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
							doc.setFont("Hauora-Regular", 'normal');
							doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), 35, verticalOffset);
						}
			       	}

			       	if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length > 0 && this.props.defaultState.verifyResults[i].contentTimestamp) {
			       		verticalOffset = verticalOffset + 5;

						if (this.props.defaultState.verifyResults[i].contentTimestamp && this.props.defaultState.verifyResults[i].contentTimestamp.dateTime) {
				            if (this.props.defaultState.verifyResults[i].contentTimestamp.isFailure) {
				            	doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
				            } else {
				            	isValid = this.props.defaultState.verifyResults[i].contentTimestamp.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

				            	doc.setFont("Hauora-ExtraBold", 'normal');
				            	doc.setTextColor("green");
				            	doc.text(i18next.t("dataTs") + ": " + isValid + "; ", 10, verticalOffset);
				            	doc.setFont("Hauora-Regular", 'normal');
				            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].contentTimestamp.dateTime), 85, verticalOffset);

				            	if (this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber) {
				            		verticalOffset = verticalOffset + 5;
				            		doc.setTextColor("black");
				            		doc.setFont("Hauora-ExtraBold", 'normal');
					            	doc.text(i18next.t("tsaCertificateSerialNumberForPdf"), 10, verticalOffset);
					            	doc.setFont("Hauora-Regular", 'normal');
					            	doc.text(this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber, 102, verticalOffset);
				            	}
				            }
				        }
			       	}

			       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
						for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
							if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime) {
								verticalOffset = verticalOffset + 5;
					            if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].isFailure) {
					            	doc.setFont("Hauora-ExtraBold", 'normal');
					            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
					            	doc.setFont("Hauora-Regular", 'normal');
					            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
					            } else {
					            	isValid = this.props.defaultState.verifyResults[i].signatureTimestamps[j].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

					            	doc.setFont("Hauora-ExtraBold", 'normal');
					            	doc.setTextColor("green");
					            	doc.text(i18next.t("dsTs") + ": " + isValid + "; ", 10, verticalOffset);
					            	doc.setFont("Hauora-Regular", 'normal');
					            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime), 88, verticalOffset);

					            	if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber) {
					            		verticalOffset = verticalOffset + 5;
					            		doc.setTextColor("black");
					            		doc.setFont("Hauora-ExtraBold", 'normal');
						            	doc.text(i18next.t("tsaCertificateSerialNumberDSForPdf"), 10, verticalOffset);
						            	doc.setFont("Hauora-Regular", 'normal');
						            	doc.text(this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber, 95, verticalOffset);
					            	}
					            }
					        }

						}
					}

					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:isElectronicStampTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), 48, verticalOffset);

					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:qualifiedCertTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), 61, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), 29, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Hauora-ExtraBold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTypeTitle"), 10, verticalOffset);
	            	doc.setFont("Hauora-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value, 39, verticalOffset);

	            	if (this.props.defaultState.verifyResults[i].signatureType && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
	            		verticalOffset = verticalOffset + 5;
						doc.setTextColor("black");
		        		doc.setFont("Hauora-ExtraBold", 'normal');
		            	doc.text(i18next.t("ds:signatureType"), 10, verticalOffset);
		            	doc.setFont("Hauora-Regular", 'normal');
		            	doc.text(this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureType), 40, verticalOffset);
	            	}

	            	if (this.props.defaultState.verifyResults[i].signatureFormat) {
	            		verticalOffset = verticalOffset + 5;
						doc.setTextColor("black");
		        		doc.setFont("Hauora-ExtraBold", 'normal');
		            	doc.text(i18next.t("ds:signatureFormat"), 10, verticalOffset);
		            	doc.setFont("Hauora-Regular", 'normal');

						if (this.props.defaultState.verifyResults[i].signatureFormat !== null && this.props.defaultState.verifyResults[i].signatureFormat === "CADES_T" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false")
						{
	                		doc.text(i18next.t("ds:CADES_TU"), 38, verticalOffset);
	                	} else {
	                		doc.text(this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureFormat), 40, verticalOffset);
	                	}
		            	
	            	}

	            	if (this.props.defaultState.verifyResults[i].signatureAlgorithmOid) {
	            		verticalOffset = verticalOffset + 5;
						doc.setTextColor("black");
		        		doc.setFont("Hauora-ExtraBold", 'normal');
		            	doc.text(i18next.t("signatureAlgorithmOid"), 10, verticalOffset);
		            	doc.setFont("Hauora-Regular", 'normal');
		            	var normilizedOid = "ds:" + normalizeOid(this.props.defaultState.verifyResults[i].signatureAlgorithmOid)
		            	doc.text(i18next.t(normilizedOid), this.props.localesReducer.language === "en" ? 47 : 44, verticalOffset)
			        }

					if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
						verticalOffset = verticalOffset + 10;
	            		doc.setTextColor("red");
	            		doc.setFont("Hauora-ExtraBold", 'normal');
		            	doc.text(i18next.t("ds:lawMsgFirstRow"), 10, verticalOffset);

		            	verticalOffset = verticalOffset + 10;
	            		doc.setTextColor("red");
	            		doc.setFont("Hauora-Regular", 'normal');
		            	doc.text(i18next.t("ds:lawMsgSecondRowPDF"), 10, verticalOffset);

		            	verticalOffset = verticalOffset + 5;
	            		doc.setTextColor("red");
	            		doc.setFont("Hauora-Regular", 'normal');
		            	doc.text(i18next.t("ds:lawMsgThirdRowPDF"), 10, verticalOffset);

		            	verticalOffset = verticalOffset + 5;
	            		doc.setTextColor("red");
	            		doc.setFont("Hauora-Regular", 'normal');
		            	doc.text(i18next.t("ds:lawMsgFourthRowPDF"), 10, verticalOffset);

		            	verticalOffset = verticalOffset + 10;
	            		doc.setTextColor("red");
	            		doc.setFont("Hauora-Regular", 'normal');
		            	doc.text(i18next.t("ds:lawMsgFifthRowPDF"), 10, verticalOffset);

		            	verticalOffset = verticalOffset + 5;
	            		doc.setTextColor("red");
	            		doc.setFont("Hauora-Regular", 'normal');
		            	doc.text(i18next.t("ds:lawMsgSixthRowPDF"), 10, verticalOffset);
					}

					if (this.props.defaultState.verifyResults[i].isUntrustedValid) {
						// verticalOffset = verticalOffset + 10;
						// doc.setFont("Hauora-ExtraBold", 'normal');
						// doc.text(i18next.t("ds:certEnded") + this.formatDate(this.props.defaultState.verifyResults[i].signerInfo.notAfter.value), 10, verticalOffset);

						verticalOffset = verticalOffset + 5;
						// var splitText = doc.splitTextToSize(i18next.t("ds:signatureValidWithUntrustedTime"), 180);
						var splitText = doc.splitTextToSize(failureCauseSplited[0], 180);
						doc.setFont("Hauora-ExtraBold", 'normal');
						doc.setTextColor("black");

						verticalOffset = verticalOffset + 5;

						for (var c = 0; c < splitText.length; c += 1){
					        doc.text(10, verticalOffset, splitText[c]);
					        verticalOffset = verticalOffset + 5;
					    }

					}
				} else {
					doc.setFont("Hauora-ExtraBold", 'normal');
					doc.setTextColor("red");
					doc.text(i18next.t("ds:signature") + (i + 1) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					if (!needSort) {
						doc.text(isValid, 43, verticalOffset);
					} else {
						doc.text(isValid, 27, verticalOffset);
					}

					var splitText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].failureCause, 180);
					doc.setFont("Hauora-Regular", 'normal');
					doc.setTextColor("black");

					verticalOffset = verticalOffset + 5;

					for (var c = 0; c < splitText.length; c += 1){
				        doc.text(10, verticalOffset, splitText[c]);
				        verticalOffset = verticalOffset + 5;
				    }
				}

			}
		}

		verticalOffset = verticalOffset + 10;
		doc.setFont("Hauora-Regular", 'normal');
		doc.setTextColor("black");
		doc.text(i18next.t("verifyAddressPdf"), 10, verticalOffset);
		doc.setTextColor("blue");
		doc.textWithLink("https://cryptocenter.cipher.com.ua/", 10, verticalOffset + 5, {url: 'https://cryptocenter.cipher.com.ua/'});

   		// doc.output("dataurlnewwindow");
   		var fileName
   		if (this.props.defaultOptionState.signatureType === "detached" && this.props.defaultState.fileInputName.length > 0) {
   			fileName = this.props.defaultState.fileInputName.substring(0, this.props.defaultState.fileInputName.indexOf('.')) || this.props.defaultState.fileInputName;
			doc.save(fileName + "-validation-report.pdf")
		} else {
			fileName = this.props.defaultState.fileWithDSName.substring(0, this.props.defaultState.fileWithDSName.indexOf('.')) || this.props.defaultState.fileWithDSName;
			doc.save(fileName + "-validation-report.pdf")
		}
	}

	formatDate(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZoneName": "short"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

    constructTimestampDetails(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result.push(<div>{tsTypeString() + i18next.t("ds:errorWhileVerifying")}</div>);
            } else {
            	result.push(
	            	<div>
	            		<div>
	            			<span className="font-weight-bold">{tsTypeString()}</span>
	            			{
			            		": "
			                    + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid"))
			                    + "; "
			                    + this.formatDate(aTs.dateTime)
		                	}
		                	{
		                		aTs.tsaCertificateSerialNumber
		                		? <div><span className="font-weight-bold">{tsaTsTypeString()}</span>
				                	{
					                    aTs.tsaCertificateSerialNumber
				                	}
				                </div>
				                : null
		                	}	                	
	            		</div>
	                </div>
                );
            }
        }
        return result;
    }

    constructTimestampDetailsText(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result = tsTypeString() + ": " + i18next.t("ds:errorWhileVerifying") + "\n";
            } else {
            	var isValid = aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
            	result = tsTypeString() + ": " + isValid + "; " + this.formatDate(aTs.dateTime) + "\n"

            	if (aTs.tsaCertificateSerialNumber) {
            		result += tsaTsTypeString() + aTs.tsaCertificateSerialNumber + "\n"
            	}
            }
        }
        return result;
    }

	showDsVerifyResults(verifyResults, elementToDisplay, resultType) {
		let rootDiv = [], divPtblg = [], diffType = [], _this = this, needSort = true, isNested = false, archTimestampCounter = 0, failureCauseSplited;
		var generateVerifyResultsViewSimple = generateVerifyResultsViewSimple.bind(this);

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];


		verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				isNested = true;
				return;
			}
		})

		if (needSort) {
			verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

        if (this.props.defaultOptionState.showUpgradeCard) {
        	verifyResults.forEach(function (element) {
	        	_this.props.defaultState.differenceSignatureType.forEach(function (secondElement) {
	        		if (element.signerInfo.certificateSerialNumber !== undefined) {
	        			if (element.signerInfo.certificateSerialNumber.value === secondElement.signerInfo.certificateSerialNumber.value) {
		        			diffType.push(secondElement)
		        		}
	        		}
	        	})
	        })
        }

        function generateVerifyResultsViewSimple (verifyResults) {
        	for (var i = 0; i < verifyResults.length; i += 1) {
	        	let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];
				let tsDetails = [];
				let tempString = [];

				if (verifyResults[i].isUntrustedValid) {
					failureCauseSplited = verifyResults[i].failureCause.split('\n')
				}

				if (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					archTimestampCounter += 1;
				}

				if (verifyResults[i].signatureTimestamps && verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < verifyResults[i].signatureTimestamps.length; j += 1) {
						tsDetails.push(this.constructTimestampDetails(verifyResults[i].signatureTimestamps[j], "signature"))
					}
				} else {
					if (!this.props.defaultOptionState.showUpgradeCard && (Object.keys(verifyResults[i].contentTimestamp).length === 0) && (verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
						tempString.push(<div style={{fontSize: "14px", color: "red"}}>
							<hr style={{marginBottom: "0px", marginTop: "5px"}} />
							<span><p>{i18next.t("ds:lawMsgFirstRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgSecondRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgThirdRow")}</p></span>
						</div>);
					}			
				}

				

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        	{	
		        		verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		    			? i18next.t("ds:ARCHIVE_TIMESTAMP")
		    			: i18next.t("ds:signature") + ((i + 1) - archTimestampCounter)
		        	}
	        	</div>)

	        	if (verifyResults[i].status === "SUCCESS") {
	        		if (resultType === "verifyResults") {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		{
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <span style={{color: "red"}}>{verifyResults[i].failureCause}</span>
			        			: null
			        		}
		        		</div>)
	        		} else {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		
		        		</div>)
	        		}
			        
			        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
		    			<div>
		    				{
		    					verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP"
		    					? <div><span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span></div>
		    					: null
		    				}
		    			</div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
					        		</div> : null
					        } {

								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
					        		</div> : null
					        } {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
						        	<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
					        		</div> : null
					        }
		    			<div>
		    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
		        		</div>
		        		 	{
					        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
					        		</div> : null
		                    }
		    			<div>
		    				{
		    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
		    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(verifyResults[i].signingDateTime)}</span></span>
		    					: null
		    				}
		    			</div>
		    			<div>
		    				{
		    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
		    				}
		    			</div>
		    			<div>
		    				{
		    					tsDetails
			                }
		    			</div>
		    			<div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureFormat ?
			                        <div>
			                        	{
			                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
			                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
			                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
			                        	}
					    				
					        		</div> : null
					        }
					        {
					        	verifyResults[i].signatureAlgorithmOid
								? <div>
					    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(verifyResults[i].signatureAlgorithmOid))}</span>
					        		</div>
								: null

					        }
					        {
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <div style={{marginTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
			        			: null
			        		}

			        		{
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:pspId") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspId.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ncaId") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaId.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ncaName") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:pspRoles") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspRoles.value}</span>
					        		</div> : null
					        }
		    			</div>
		    		</div>)

		        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
		        		{	
		        			this.props.defaultOptionState.showUpgradeCard && (diffType[i].previousSignatureFormat === "CADES_X_LONG" ? true : false)
				    		? <div className="alert alert-warning">
				        		{i18next.t("ds:alreadyModifiedTitle")}
				        	</div>
				        	: null
		        		}
		        		{
							 <div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}{(verifyResults[i].signatureImageData !== null && verifyResults[i].signatureImageData !== undefined && verifyResults[i].signatureImageData.length > 0 && this.props.base.padesEnabled === "true") ? <div style={{paddingRight: "15px"}}><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>{i18next.t("hwsImageLabel")}</label><img style={{maxWidth: "100%", maxHeight: "100%", cursor: "pointer"}} src={"data:image/png;base64," + verifyResults[i].signatureImageData} onClick={this.handleShowPrivateSign.bind(this, verifyResults[i].signatureImageData)} alt="" /></div> : null}{this.props.defaultOptionState.generateQR ? <div><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px", paddingTop: "10px"}}>{i18next.t("QRSignLabel")}</label><img src={this.props.defaultState.verifyResultsForQR[i]} onClick={this.handleShowQR.bind(this, i)} style={{width: "100px", height: "100px", cursor: "pointer"}} alt="" /></div> : null}</div><div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        		<div>
					        		{
					        			tempString
					        		}
					        	</div>
				        	</div>
				        }
		        	</div>)
		        } else {
		        	if (verifyResults[i].isUntrustedValid) {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        	</div>)
		        		signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
			    			</div>
			    				{
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
							        	<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
						        		<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
						        		</div> : null
						        }
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
			        		</div>
			        		 	{
						        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
						        		</div> : null
			                    }
			    			<div>
			    				{
			    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
			    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(verifyResults[i].signingDateTime)}</span></span>
			    					: null
			    				}
			    			</div>
			    			<div>
			    				{
			    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
			    				}
			    			</div>
			    			<div>
			    				{
			    					tsDetails
				                }
			    			</div>
			    			<div>
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureType ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureFormat ?
				                        <div>
				                        	{
				                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
				                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
				                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
				                        	}
						    				
						        		</div> : null
						        }
						        {
						        	verifyResults[i].signatureAlgorithmOid
									? <div>
						    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(verifyResults[i].signatureAlgorithmOid))}</span>
						        		</div>
									: null

						        }
						        {
						            verifyResults[i].isUntrustedValid
						            ? <div><p></p>
						            	<div>
						            		{
						            			<p><b>{failureCauseSplited[0]}</b></p>
						            		}
						            		
						            		{/*<p style={{"marginBottom": "0.5rem"}}><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></p>*/}
						            	</div>
						            </div>
						            : null
						        }
			    			</div>
			    		</div>)
						divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	} else {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        		</div>)
				        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
				    			<div>
				    				{ verifyResults[i].failureCause }
				    				{
							            verifyResults[i].isUntrustedValid
							            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
							            : null
							        }
				    			</div>
			    			</div>)
			        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	}
			        
	            }
	        }
        }

		// const generateVerifyResultsView = (verifyResultsData, depth = 0) => {
		//   if (!verifyResultsData || verifyResultsData.length === 0) return null;

		//   const verifyResults = Array.isArray(verifyResultsData) ? verifyResultsData : [verifyResultsData];

		//   return (
		//     <div className={depth === 0 ? "depth-margin" : "depth"}>
		//       {verifyResults.map((result, index) => (
		//         <div key={index}>
		            
		//           	{
		//           		result.status === "SUCCESS"
		//         		? <div className={(result.isValid) ? ((result.verifyResults === undefined && index === verifyResults.length - 1) ? "alert-last alert-success" : "alert alert-success") : (result.verifyResults === undefined ? "alert-last alert-warning" : "alert alert-warning")}>

		//         			<div className="row">
		// 	        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>
		// 		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		// 				    			{i18next.t("ds:signature") + (index + 1 + depth)}
		// 				        	</div>
			        				
		// 	        				{
		// 		        				resultType === "verifyResults"
		// 		        				? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
		// 					        			{
		// 					        				result.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		// 					        			}
		// 					        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		// 						        			{
		// 						        				(result.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && result.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
		// 						        			}
		// 						        		</div>
		// 						        		{
		// 						        			result.failureCause !== null && result.failureCause !== undefined && result.failureCause.length > 0
		// 						        			? <span style={{color: "red"}}>{result.failureCause}</span>
		// 						        			: null
		// 						        		}
		// 					        		</div>
		// 		        				:   <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
		// 					        			{
		// 					        				result.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		// 					        			}
		// 					        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		// 						        			{
		// 						        				(result.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && result.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
		// 						        			}
		// 						        		</div>
		// 						        		{
		// 						        			result.failureCause !== null && result.failureCause !== undefined && result.failureCause.length > 0
		// 						        			? <span style={{color: "red"}}>{result.failureCause}</span>
		// 						        			: null
		// 						        		}
		// 					        		</div>
		// 		        			}

		// 	        				{this.props.defaultOptionState.generateQR
		// 		        				? <img src={this.props.defaultState.verifyResultsForQR[i]} onClick={this.handleShowQR.bind(this, i)} style={{width: "100px", height: "100px", marginLeft: "15px", cursor: "pointer"}} alt="" />
		// 		        				: null} 
		// 	        			</div> 
		// 		        			<div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">
		// 		        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
		// 			    			<div>
		// 			    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{result.signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
		// 			    			</div>
		// 			    				{
		// 									result.signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{result.signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
		// 						        		</div> : null
		// 						        } {
		// 									result.signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{result.signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
		// 						        		</div> : null
		// 						        } {
		// 									result.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{result.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
		// 						        		</div> : null
		// 						        } {
		// 						        	result.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
		// 							        	<div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ result.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
		// 						        		</div> : null
		// 						        } {
		// 						        	result.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
		// 						        		<div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ result.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
		// 						        		</div> : null
		// 						        }
		// 			    			<div>
		// 			    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{result.signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
		// 			        		</div>
		// 			        		 	{
		// 						        	result.signerInfo.certificateSerialNumber.value ? 
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{result.signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
		// 						        		</div> : null
		// 			                    }
		// 			    			<div>
		// 			    				{
		// 			    					result.signingDateTime !== undefined && result.signingDateTime.length > 0
		// 			    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(result.signingDateTime)}</span></span>
		// 			    					: null
		// 			    				}
		// 			    			</div>
		// 			    			<div>
		// 			    				{
		// 			    					this.constructTimestampDetails(result.contentTimestamp, "content")
		// 			    				}
		// 			    			</div>
		// 			    			<div>
		// 			    				{
		// 			    					result.signatureTimestamps.map((element) => (
		// 			    						this.constructTimestampDetails(element, "signature")
		// 			    					))
		// 			    				}
					    				
		// 			    			</div>
		// 			    			<div>
		// 			    				{
		// 									result.signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{result.signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
		// 						        		</div> : null
		// 						        }
		// 			    				{
		// 									result.signerInfo.extensionsCertificateInfo.value.isQualified ?
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{result.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
		// 						        		</div> : null
		// 						        }
		// 						        {
		// 									result.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{result.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
		// 						        		</div> : null
		// 						        }
		// 						        {
		// 									result.signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{result.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : result.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
		// 						        		</div> : null
		// 						        }
		// 						        {
		// 									result.signatureType ?
		// 				                        <div>
		// 						    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{result.signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + result.signatureType)}</span>
		// 						        		</div> : null
		// 						        }
		// 						        {
		// 									result.signatureFormat ?
		// 				                        <div>
		// 				                        	{
		// 				                        		result.signatureFormat !== null && result.signatureFormat === "CADES_T" && result.signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
		// 				                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
		// 				                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{result.signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + result.signatureFormat)}</span></div>
		// 				                        	}
								    				
		// 						        		</div> : null
		// 						        }
		// 			    			</div>
		// 			    		</div>
		// 	        			</div>
		// 	        		</div>        			
		        			
		        				
		//         		  </div>
		//         		: <div>
		//         			<div className={(result.isValid) ? "alert alert-success" : "alert alert-warning"}>
		// 		        		<div className="row">
		// 		        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">
		// 		        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		// 					    			{i18next.t("ds:signature") + (index + 1 + depth)}
		// 					        	</div>
		// 		        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		// 				        			{i18next.t("ds:notDefined")}
		// 				        		</div>
		// 		        			</div>
		// 		        			<div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">
		// 		        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
		// 					    			<div>
		// 					    				{ result.failureCause }
		// 					    				{
		// 								            result.isUntrustedValid
		// 								            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
		// 								            : null
		// 								        }
		// 					    			</div>
		// 				    			</div>
		// 		        			</div>
		// 		        		</div>
		// 		        	</div>
		//         		</div>
		//           	}
		//           {result.verifyResults && result.verifyResults.length > 0 && (
		//             generateVerifyResultsView(result.verifyResults, depth + 1)
		//           )}
		//         </div>
		//       ))}
		//     </div>
		//   );
		// };

		// const renderVerifyResultsWithSeparation = (verifyResults) => {
		//   if (!verifyResults) return null;

		//   const resultsArray = Array.isArray(verifyResults) ? verifyResults : [verifyResults];

		//   return (
		//     <div>
		//       {resultsArray.map((resultsGroup, index) => (
		//         <div key={index}>
		//           {generateVerifyResultsView(resultsGroup)}
		//         </div>
		//       ))}
		//     </div>
		//   );
		// };

		function buildTree(items) {
		  const tree = [];
		  const lastAtLevel = {}; // останній вузол на кожному рівні

		  items.forEach(item => {
		    const level = item.degreeOfNesting !== undefined
		      ? Number(item.degreeOfNesting)
		      : 0;

		    const node = { ...item, children: [] };

		    if (level === 0) {
		      tree.push(node);
		      lastAtLevel[0] = node;
		    } else {
		      const parent = lastAtLevel[level - 1];
		      if (parent) {
		        parent.children.push(node);
		      } else {
		        console.warn("No parent found for node:", node);
		        tree.push(node); // fallback
		      }
		      lastAtLevel[level] = node;
		    }

		    // очищаємо всі вузли глибше поточного рівня
		    Object.keys(lastAtLevel).forEach(k => {
		      if (Number(k) > level) delete lastAtLevel[k];
		    });
		  });

		  return tree;
		}

		function addIds(items) {
		  return items.map((item, index) => ({
		    ...item,
		    id: index + 1
		  }));
		}

		const updatedData = addIds(verifyResults);

		const tree = buildTree(updatedData);

		const TreeNode = ({ node }) => {
		  return (
		    <div style={styles.parent}>
		      <div>
		          	{
		          		node.status === "SUCCESS"
		        		? <div className={(node.isValid) ? "alert-last alert-success" : "alert-last alert-warning"}>

		        			<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>
				        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
						    			{i18next.t("ds:signature") + node.id}
						        	</div>
			        				
			        				{
				        				resultType === "verifyResults"
				        				? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
							        			{
							        				node.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
							        			}
							        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
								        			{
								        				(node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
								        			}
								        		</div>
								        		{
								        			node.failureCause !== null && node.failureCause !== undefined && node.failureCause.length > 0
								        			? <span style={{color: "red"}}>{node.failureCause}</span>
								        			: null
								        		}
							        		</div>
				        				:   <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
							        			{
							        				node.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
							        			}
							        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
								        			{
								        				(node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
								        			}
								        		</div>
								        		{
								        			node.failureCause !== null && node.failureCause !== undefined && node.failureCause.length > 0
								        			? <span style={{color: "red"}}>{node.failureCause}</span>
								        			: null
								        		}
							        		</div>
				        			}

			        				{this.props.defaultOptionState.generateQR
				        				? <img src={this.props.defaultState.verifyResultsForQR[node.id - 1]} onClick={this.handleShowQR.bind(this, node.id - 1)} style={{width: "100px", height: "100px", marginLeft: "15px", cursor: "pointer"}} alt="" />
				        				: null} 
			        			</div> 
				        			<div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
					    			<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
					    			</div>
					    				{
											node.signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
								        		</div> : null
								        } {
											node.signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
								        		</div> : null
								        } {
											node.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
								        		</div> : null
								        } {
								        	node.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
									        	<div>
								    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ node.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
								        		</div> : null
								        } {
								        	node.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
								        		<div>
								    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ node.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
								        		</div> : null
								        }
					    			<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{node.signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
					        		</div>
					        		 	{
								        	node.signerInfo.certificateSerialNumber.value ? 
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{node.signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
								        		</div> : null
					                    }
					    			<div>
					    				{
					    					node.signingDateTime !== undefined && node.signingDateTime.length > 0
					    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(node.signingDateTime)}</span></span>
					    					: null
					    				}
					    			</div>
					    			<div>
					    				{
					    					this.constructTimestampDetails(node.contentTimestamp, "content")
					    				}
					    			</div>
					    			<div>
					    				{
					    					node.signatureTimestamps.map((element) => (
					    						this.constructTimestampDetails(element, "signature")
					    					))
					    				}
					    				
					    			</div>
					    			<div>
					    				{
											node.signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
					    				{
											node.signerInfo.extensionsCertificateInfo.value.isQualified ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : node.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
								        		</div> : null
								        }
								        {
											node.signatureType ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{node.signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + node.signatureType)}</span>
								        		</div> : null
								        }
								        {
											node.signatureFormat ?
						                        <div>
						                        	{
						                        		node.signatureFormat !== null && node.signatureFormat === "CADES_T" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
						                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
						                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{node.signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + node.signatureFormat)}</span></div>
						                        	}
								    				
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:pspId") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspId.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:ncaId") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaId.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:ncaName") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaName.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:pspRoles") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspRoles.value}</span>
								        		</div> : null
								        }
								        {
								        	node.signatureAlgorithmOid
											? <div>
								    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(node.signatureAlgorithmOid))}</span>
								        		</div>
											: null

								        }
					    			</div>
					    		</div>
			        			</div>
			        		</div>        			
		        			
		        				
		        		  </div>
		        		: <div>
		        			<div className={(node.isValid) ? "alert-last alert-success" : "alert-last alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
							    			{i18next.t("ds:signature") + node.id}
							        	</div>
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
						        			{i18next.t("ds:notDefined")}
						        		</div>
				        			</div>
				        			<div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
							    			<div>
							    				{ node.failureCause }
							    				{
										            node.isUntrustedValid
										            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
										            : null
										        }
							    			</div>
						    			</div>
				        			</div>
				        		</div>
				        	</div>
		        		</div>
		          	}
		          
		        </div>
		      {node.children.length > 0 && (
		        <div style={styles.children}>
		          {node.children.map((child, index) => (
		          	node.children.length > 1 && ((index + 1) % 2 === 0)
		          	? <div style={{marginTop: "10px"}}><TreeNode key={child.id} node={child} /></div>
		          	: <TreeNode key={child.id} node={child} />
		          ))}
		        </div>
		      )}
		    </div>
		  );
		};

		const TreeView = ({ data }) => {
			console.log("tree", JSON.stringify(tree, null, 2));
		  return (
		    <div style={styles.tree}>
		      {data.map((node, index) => (
		        <TreeNode key={node.id} node={node} />
		      ))}
		    </div>
		  );
		};

		const styles = {
		  tree: {
		    display: "flex",
		    flexDirection: "column",
		    marginBottom: "10px"
		  },
		  parent: {
		    padding: "10px",
		    border: "1px solid rgba(0, 0, 0, 0.125)",
		    borderRadius: "5px"
		  },
		  node: {
		    padding: "10px",
		    border: "1px solid rgba(0, 0, 0, 0.125)",
		    borderRadius: "5px"
		  },
		  children: {
		    marginTop: "10px"
		  }
		};

		function generateModifyResults (verifyResults) {
			for (var i = 0; i < verifyResults.length; i += 1) {
				let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];		

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
	    			{i18next.t("ds:signature") + (i + 1)}
	        	</div>)
	        		
    			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
        			{
        				verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat ? i18next.t("ds:isNotModified") : i18next.t("ds:isModified")
        			}
        		</div>)
		        
		        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
	    			</div>
	    				{
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
					        	<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
				        		<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
				        		</div> : null
				        }
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
	        		</div>

	        		{
	        			verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat
	        			? <div>
							{
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }
	        			</div>
	        			: <div>
		        			{
					        	verifyResults[i].previousSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureFormat) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }

					        {
					        	verifyResults[i].previousSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					    </div>
	        		}
	        		{
	        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
	        			? <div style={{paddingTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
	        			: null
	        		}
	        		
	    		</div>)

	        	divPtblg.push(<div className="ptblg-default" style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
	        		{
						 <div className={(verifyResults[i].status === "SUCCESS") ? "alert alert-success" : "alert alert-warning"}>
			        		<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
			        		</div>
			        	</div>
			        }
	        	</div>)
			}
		}


		if (!this.props.defaultOptionState.showUpgradeCard) {
			if (isNested) {
	        	rootDiv.push(<div id="divPtblg">{
	        		<TreeView data={tree} />
	        	}</div>)
	        } else {
	        	generateVerifyResultsViewSimple(verifyResults)
	        	rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
	        }
		} else {
			generateModifyResults(_this.props.defaultState.differenceSignatureType)
	        rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
		}
          
        return rootDiv

    }

    showPreviewPopupVerify () {
		this.props.actions.setShowPreviewPopupVerify(true);
	}

	render () {
		const isEnabled = this.props.defaultOptionState.signatureType === 'detached' ?
				this.props.defaultState.fileInputSelected && this.props.defaultState.fileWithDSSelected
				: this.props.defaultState.fileWithDSSelected;

		const isEnabledDownload = this.props.defaultState.fileSignedData ? true : false;

		const isPreviewEnabled = this.props.defaultState.fileSignedData && this.props.defaultState.fileWithDSName ? true : false

		const isEnabledDownloadModifiedDS = this.props.upgradeReducer.modifiedDSData ? true : false;

		return (
			<div>
	            <div className="row" style={{paddingTop: "10px"}}>
	            <VerifyDSOptionsContainer />
	              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
	                <div className="card">
	                  <div className="card-header" onClick={this.expandVerifyDS.bind(this)} role="button">
	                    {
							this.props.expandedCardsReducer.verifyExpanded ? <i className="fa fa-chevron-down" aria-hidden="true" style={{"cursor": "pointer"}}></i>
								: <i className="fa fa-chevron-up" aria-hidden="true" style={{"cursor": "pointer"}}></i>
						}&nbsp;{i18next.t("file")}
	                  </div>
	                  <div className={this.state.collapseVerifyDSShow} data-toggle="collapse" aria-expanded={this.props.expandedCardsReducer.verifyExpanded}>
	                    <div>
	                    	{
	                    		this.props.defaultOptionState.signatureType === 'detached'
	                    		? <div className="no-left-right-padding">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileForVerifyingTitle")}</label>
	                    			{
	                    				this.props.base.googleDriveEnabled === "true"
	                    				? <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
			                                {
			                                  this.props.mobileModeReducer.mobileDeviceMode
			                                  ? 
			                                  <div className="input-group row" style={{marginLeft: "0px"}}>
			                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
			                                    {
													this.props.defaultState.fileInputSelected
													? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("changeFile")}</button>
													: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("chooseFile")}</button>
												}

			                                  </div>
			                                  : <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                  		{
		                                  			this.props.defaultState.fileInputSelected
		                                  			? <div className="input-group mb-4">
														<input type="text" className="form-control" value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
														<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
								                    : <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{marginLeft: "0px", marginRight: "0px"}}>
								                    	{
								                    		this.props.base.googleDriveEnabled === "true"
								                    		? <div className="row">
								                    			<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 padding-left-0-gdrive">
									                    			<Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
												                        {({getRootProps, getInputProps}) => (
												                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone col-lg-12 col-md-12 col-xs-12 col-sm-12" id="dropFile" style={{marginBottom: "10px"}}>
												                                <input {...getInputProps()} />
												                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
												                            </div>
												                        )}
												                    </Dropzone>
												                </div>
											                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 no-left-padding-gdrive padding-left-0-gdrive">
																	<GooglePicker caller={"fileInput"} />
																</div>
								                    		</div>
								                    		: <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
										                        {({getRootProps, getInputProps}) => (
										                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone col-lg-12 col-md-12 col-xs-12 col-sm-12" id="dropFile">
										                                <input {...getInputProps()} />
										                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
										                            </div>
										                        )}
										                    </Dropzone>
								                    	}
														
								                    </div>
			                                	}
			                                </div>
			                            }
		                                </div>
	                    				: <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
			                                {
			                                  this.props.mobileModeReducer.mobileDeviceMode
			                                  ? 
			                                  <div className="input-group row" style={{marginLeft: "0px"}}>
			                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
			                                    {
													this.props.defaultState.fileInputSelected
													? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("changeFile")}</button>
													: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("chooseFile")}</button>
												}

			                                  </div>
			                                  : <div>
			                                  		{
			                                  			this.props.defaultState.fileInputSelected
			                                  			? <div className="input-group mb-4">
															<input type="text" className="form-control" value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
															<div className="input-group-append">
														      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup")}</button>
														    </div>
														</div>
									                    : <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
									                        {({getRootProps, getInputProps}) => (
									                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropFile">
									                                <input {...getInputProps()} />
									                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
									                            </div>
									                        )}
									                    </Dropzone>
			                                  		}
												</div>
			                                }
		                                </div>
	                    			}
	                                <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                            </div>
								: <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                    	}

	                    	<div className="no-left-right-padding" style={{marginBottom: "10px"}}>
                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileWithDsTitle")}</label>
                    			{
                    				this.props.base.googleDriveEnabled === "true"
                    				? <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                {
		                                  this.props.mobileModeReducer.mobileDeviceMode
		                                  ? 
		                                  <div className="input-group row" style={{marginLeft: "0px"}}>
		                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
		                                    {
												this.props.defaultState.fileWithDSSelected
												? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("changeFile")}</button>
												: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("chooseFile")}</button>
											}
		                                    </div>
		                                    : <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                  		{
		                                  			this.props.defaultState.fileWithDSSelected
		                                    		? <div className="input-group mb-4">
														<input type="text" className="form-control" value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
														<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithDSSelect.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
													: <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{marginLeft: "0px", marginRight: "0px"}}>
								                    	{
								                    		this.props.base.googleDriveEnabled === "true"
								                    		? <div className="row">
								                    			<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 padding-left-0-gdrive">
									                    			<Dropzone ref={dropzoneDSRef} onDrop={this.handleOnDropDS} multiple={false}>
												                        {({getRootProps, getInputProps}) => (
												                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone col-lg-12 col-md-12 col-xs-12 col-sm-12" id="dropDS">
												                                <input {...getInputProps()} />
												                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
												                            </div>
												                        )}
												                    </Dropzone>
											                    </div>
											                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 no-left-padding-gdrive padding-left-0-gdrive">
																	<GooglePicker caller={"fileWithDS"} />
																</div>
								                    		</div>
								                    		: <Dropzone ref={dropzoneDSRef} onDrop={this.handleOnDropDS} multiple={false}>
										                        {({getRootProps, getInputProps}) => (
										                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone col-lg-12 col-md-12 col-xs-12 col-sm-12" id="dropDS">
										                                <input {...getInputProps()} />
										                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
										                            </div>
										                        )}
										                    </Dropzone>
								                    	}
														
								                    </div>
		                                  		}
											</div>
		                                    
		                                }
	                                </div>
                    				: <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                {
		                                  this.props.mobileModeReducer.mobileDeviceMode
		                                  ? 
		                                  <div className="input-group row" style={{marginLeft: "0px"}}>
		                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
		                                    {
												this.props.defaultState.fileWithDSSelected
												? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("changeFile")}</button>
												: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("chooseFile")}</button>
											}
		                                    </div>
		                                    : <div>
		                                    	{
		                                    		this.props.defaultState.fileWithDSSelected
		                                    		? <div className="input-group mb-4">
														<input type="text" className="form-control" value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
														<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithDSSelect.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
													: <div><Dropzone ref={dropzoneDSRef} onDrop={this.handleOnDropDS} multiple={false}>
								                        {({getRootProps, getInputProps}) => (
								                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropDS">
								                                <input {...getInputProps()} />
								                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
								                            </div>
								                        )}
								                    </Dropzone>
								                    </div>
		                                    	}
		                                      </div>
		                                    
		                                }
	                                </div>
                    			}
                                <input id="fileWithDSUpload" type="file" onChange={this.onChangeDS.bind(this)} style={{"display": "none"}} />
                            </div>
                            {
                            	(!this.props.base.isLoading && this.props.defaultState.verifyResults && this.props.defaultState.verifyResults.length > 0 && !this.props.defaultOptionState.showUpgradeCard)
                            	? <div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "left", marginTop: "-10px", marginBottom: "10px"}}>
		                            	<span style={{cursor: "pointer", color: "#1a0dab", textAlign: "left"}} onClick={this.saveVerifyResultsToPdf}>{i18next.t("inspectionReport")}</span>
		                        	</div>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "right", marginTop: "-10px", marginBottom: "10px"}}>
		                            	<span id="copyLink" style={{cursor: "pointer", color: "#1a0dab", textAlign: "right"}} onClick={this.copyVerifyResults}>{i18next.t("copyVerifyDSResultToClipboardTitle")}</span>
		                        	</div>
		                        </div>
                            	: null
                            }

                            {
                            	this.props.defaultOptionState.generateQR
                            	? (!this.props.base.isLoading && this.props.defaultState.verifyResults && this.props.defaultState.verifyResultsForQR) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            	: (!this.props.base.isLoading && this.props.defaultState.verifyResults) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            }

							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-0 order-md-4">
			                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.setInputState.bind(this)} disabled={!isEnabled}>{this.props.defaultOptionState.showUpgradeCard ? i18next.t("ds:modifyDs") : i18next.t("ds:verifyDs")}
			                        	{
			                              	this.props.base.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
			                        </button>
		                        </div>
		                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-2 order-md-6 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
	                        </div>
	                        {
	                        	this.props.defaultOptionState.signatureType === 'attached' && !this.props.defaultOptionState.showUpgradeCard
	                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-1 no-left-right-padding" style={{"marginLeft": "0px", "marginRight": "0px"}}>
	                        		{
	                        			this.props.base.googleDriveEnabled === "true"
	                        			? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row no-left-right-margin no-left-right-padding">
	                        				<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding" style={{paddingTop: "0px"}}>{i18next.t("ds:saveSignedDataButton")}</label>
	                        				<div className={(this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName)) ? "col-lg-6 col-md-6 col-sm-12 col-xs-12 no-left-padding row no-left-right-margin no-left-right-padding-gdrive saveButtonToLocal" : "col-lg-6 col-md-6 col-sm-12 col-xs-12 no-left-padding saveButtonToLocal row no-left-right-margin no-left-right-padding"}>
		                        				{
				                        			this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName)
				                        			? <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 padding-right0-eye">
				                        				<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px", paddingLeft: "0px", paddingRight: "0px"}} disabled={!isPreviewEnabled} onClick={this.showPreviewPopupVerify}>
				                        					<i className="fa fa-eye minus-margin"></i>
				                        				</button>
				                        			</div>
				                        			: null
				                        		}
	                        					<div className={(this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName)) ? "col-lg-11 col-md-11 col-sm-11 col-xs-11 padding-right0" : "col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-no-right-padding padding-right0" }>
		                        					<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isEnabledDownload} onClick={this.downloadSignedData.bind(this)}>{i18next.t("saveToLocal")}</button>
		                        				</div>
	                        				</div>

	                        				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-left-right-padding saveButtonToGDrive">
	                        					<button id="uploadFiletoGoogleDriveButton" className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding gDriveUploadButton" disabled={!isEnabledDownload} onClick={() => this.openFolderPicker()}>
			                        				<img className="img" src={logo} width="24" height="24" alt="Logo" />{i18next.t("saveToGDrive")}
			                        			</button>
	                        				</div>
	                        			</div>
	                        			: <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row no-left-no-right-padding no-left-right-margin">
	                        				{
			                        			this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName)
			                        			? <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 padding-right0-eye"><button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isPreviewEnabled} onClick={this.showPreviewPopupVerify}><i className="fa fa-eye minus-margin"></i></button></div>
			                        			: null
			                        		}
			                        		<div className={(this.props.base.previewEnabled === "true" && this.props.defaultState.fileSignedData && this.props.actions.checkExtensionVerify(this.props.defaultState.fileWithDSName)) ? "col-lg-11 col-md-11 col-sm-11 col-xs-11 padding-right0" : "col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-no-right-padding" }>
	                        					<button className={this.props.base.googleDriveEnabled === "true" ? "btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" : "btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-right0"} style={{marginBottom: "10px"}} disabled={!isEnabledDownload} onClick={this.downloadSignedData.bind(this)}>{i18next.t("ds:saveSignedDataButton")}</button>
	                        				</div>
	                        			</div>
	                        		}

	                        	</div>
	                        	: null
	                        }
	                        <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.downloadModifiedData.bind(this)}>{i18next.t("ds:downloadModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
		                    <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div style={{marginTop: "10px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.verifyModifiedData.bind(this)}>{i18next.t("ds:verifyModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>

	                    </div>
	                    </div>
	                   </div>
	                   <VerifyTextDSContainer />
	                </div>
	                <div>
		                {
							this.props.base.showPreviewPopupVerify
							? <PreviewPopup file={this.props.defaultState.fileSignedData} />
							: null
						}
	                    {
	                        this.state.showPopup
	                        ? <QRPopup closeQRPopup={this.handleShowQR} data={this.state.displayedData} />
	                        : null
	                    }
	                    {
	                        this.state.showPrivateSignPopup
	                        ? <PrivateSignPopup closePrivateSignPopup={this.handleShowPrivateSign} data={this.state.displayedData} />
	                        : null
	                    }
	                </div>
	            </div>
	        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
    	base: state.base,
        language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        defaultState: state.verifyDSInputReducer,
        defaultOptionState: state.verifyDSOptionsReducer,
        mobileModeReducer: state.mobileModeReducer,
        expandedCardsReducer: state.expandedCardsReducer,
        upgradeReducer: state.upgradeDSReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setVerifyInputFile,
    	setVerifyDSInputFile,
    	clearVerifyInputFile,
    	clearVerifyDSInputFile,
    	clearVerifyResultData,
    	clearFileSignedData,
    	setVerifyDSExpand,
    	clearModifiedDSData,
    	setIsLoading,
    	setSignatureDifferenceType,
    	clearSignatureDifferenceType,
    	checkExtensionVerify, setShowPreviewPopupVerify,
    	fromBytes, setGoogleAccessToken, setGoogleTokenExpiryTime,
    	setShowUpgradeCard
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDSTab);